import classNames from 'classnames';
import { ClientEvents } from 'common/events/ClientEvents';
import React from 'react';
import { useTracker } from 'tracking/useTracker';

interface IProps {
  className?: string;
  scrollRight: () => void;
  scrollLeft: () => void;
  numElementsLeft?: number;
  numElementsRight?: number;
  hasBackgroundColor?: boolean;
  elementName: string;
}

export const ScrollButtons: React.FC<IProps> = ({
  className,
  scrollRight,
  scrollLeft,
  numElementsLeft,
  numElementsRight,
  hasBackgroundColor,
  elementName,
}) => {
  const tracker = useTracker();

  const getScrollButtonClickHandler = (direction: 'left' | 'right') => () => {
    tracker.track(ClientEvents.SEGMENT_ARROW_CLICK, { direction, elementName });
    direction === 'left' ? scrollLeft() : scrollRight();
  };

  const arrowClass = classNames('absolute', `top-3`, `left-3`, hasBackgroundColor ? 'text-white' : 'text-radish-200');
  const scrollButtonClass = classNames(
    'absolute',
    `w-10`,
    `h-10`,
    'border-[1.25px]',
    'border-neutral-100',
    'rounded-full',
    hasBackgroundColor ? 'bg-neutral-100' : 'bg-white',
    hasBackgroundColor ? 'opacity-20' : 'opacity-100'
  );

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      <div
        className={`relative size-10 transition-opacity ${classNames({
          'cursor-pointer': numElementsRight === 0,
          'opacity-30': numElementsRight === 0,
        })}`}
        onClick={getScrollButtonClickHandler('right')}>
        <div className={scrollButtonClass} />
        <i className={`fas fa-arrow-right ${arrowClass}`} />
      </div>

      <div
        className={`relative size-10 transition-opacity ${classNames({
          'cursor-pointer': numElementsLeft === 0,
          'opacity-30': numElementsLeft === 0,
        })}`}
        onClick={getScrollButtonClickHandler('left')}>
        <div className={scrollButtonClass} />
        <i className={`fas fa-arrow-left ${arrowClass}`} />
      </div>
    </div>
  );
};
